import { IServiceTask } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ServiceTaskChannel } from 'src/app/business/serviceTask/contracts/service-task-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { ServiceTaskModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class ServiceTaskSyncService extends SyncService<IServiceTask> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IServiceTask>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(ServiceTaskModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return (
      channel === ServiceTaskChannel.CREATE ||
      channel === ServiceTaskChannel.EDIT ||
      channel === ServiceTaskChannel.DELETE
    );
  }
}
